export default function request(url, config) {
  const _request = function _request (type, payload, body) {
    return new Promise((resolve) => {
      /* eslint-disable */
      if (!payload) payload = {};

      const req = new XMLHttpRequest();
      req.addEventListener("load", function () {
        let res;
        try {
          res = JSON.parse(this.responseText);
        } catch (e) {
          res = this.responseText;
        }

        resolve(res);
      });

      req.open(type, url);

      if (type !== "GET") {
        // if this is in a "GET" request it will change it to "OPTIONS", which
        // we don't want.
        req.setRequestHeader("Content-Type", "application/json");
      }

      if (payload.headers) {
        Object.keys(payload.headers).forEach((o) => {
          req.setRequestHeader(o, payload.headers[o]);
        });
      }

      // this is for being able to read cookies on a given incoming request
      // server-side so I can tailor the request to a particular user.
      // the server has the right to deny this request if the origin is not
      // approved.
      if (payload.credentials === true) {
        req.withCredentials = true;
      }

      req.send(typeof body === "string" ? body : JSON.stringify(body));
    });
  };

  // return the four basic transmission commands to the server.
  return {
    get: function get (data) {
      return _request("GET", config, data);
    },
    post: function post (data) {
      return _request("POST", config, data);
    },
    put: function put (data) {
      return _request("PUT", config, data);
    },
    patch: function patch (data) {
      return _request("PATCH", config, data);
    }
  };
};



// WEBPACK FOOTER //
// ./src/js/request.js